import { render } from "./VehicleSelectWrapperComponent.vue?vue&type=template&id=478886d0&ts=true"
import script from "./VehicleSelectWrapperComponent.vue?vue&type=script&lang=ts"
export * from "./VehicleSelectWrapperComponent.vue?vue&type=script&lang=ts"

import "./VehicleSelectWrapperComponent.vue?vue&type=style&index=0&id=478886d0&lang=scss"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__